function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  "data-name": "path1",
  d: "M10.73 4.21a.79.79 0 01.11 1.11.76.76 0 01-1.08.12L5.51 1.85 1.29 5.31a.78.78 0 01-1.1-.12.84.84 0 01.12-1.13L5 .2a.76.76 0 011 0z",
  fillRule: "evenodd"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  "data-name": "path2",
  d: "M10.84 10.86a.79.79 0 01-.09 1.14L6 15.85a.81.81 0 01-1 0l-4.71-4a.82.82 0 01-.29-.63.78.78 0 01.18-.51.76.76 0 011.08-.12l4.24 3.6 4.22-3.45a.76.76 0 011.07.06z",
  fillRule: "evenodd"
});

function SvgIconSortArrows(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Ebene 1",
    viewBox: "0 0 11.05 16.09"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyBkYXRhLW5hbWU9IkViZW5lIDEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgdmlld0JveD0iMCAwIDExLjA1IDE2LjA5Ij4KICAgIDxkZWZzPgogICAgICAgIDxzdHlsZT4KICAgICAgICAgICAgLmNscy0xLCAuY2xzLTIgewogICAgICAgICAgICAgICAgZmlsbC1ydWxlOiBldmVub2RkOwogICAgICAgICAgICB9CiAgICAgICAgPC9zdHlsZT4KICAgIDwvZGVmcz4KICAgIDxwYXRoIGRhdGEtbmFtZT0icGF0aDEiIGNsYXNzPSJjbHMtMSIKICAgICAgICAgIGQ9Ik0xMC43Myw0LjIxYS43OS43OSwwLDAsMSwuMTEsMS4xMWgwYS43Ni43NiwwLDAsMS0xLjA4LjEyaDBMNS41MSwxLjg1LDEuMjksNS4zMWEuNzguNzgsMCwwLDEtMS4xLS4xMmgwQS44NC44NCwwLDAsMSwuMzEsNC4wNmgwTDUsLjJhLjc2Ljc2LDAsMCwxLDEsMEg2WiIvPgogICAgPHBhdGggZGF0YS1uYW1lPSJwYXRoMiIgY2xhc3M9ImNscy0yIgogICAgICAgICAgZD0iTTEwLjg0LDEwLjg2QS43OS43OSwwLDAsMSwxMC43NSwxMmwwLDBoMEw2LDE1Ljg1YS44MS44MSwwLDAsMS0xLDBINWwtNC43MS00QS44Mi44MiwwLDAsMSwwLDExLjIyYS43OC43OCwwLDAsMSwuMTgtLjUxLjc2Ljc2LDAsMCwxLDEuMDgtLjEybDAsMGgwTDUuNSwxNC4xOWw0LjIyLTMuNDVhLjc2Ljc2LDAsMCwxLDEuMDcuMDZaIi8+Cjwvc3ZnPgo=";
export { SvgIconSortArrows as ReactComponent };